// Commonly-used arrays of tags to be used with the striptags function

// Example:
// const strippedSubtitle = striptags(subtitle, subtitleTags, "");
// <p dangerouslySetInnerHTML={{__html: strippedSubtitle}} />

// Should be used inside block-level tag like <p> or a heading
const subtitleTags = ['a','b','strong','em','i','sup','sub',];

// Supports paragraphs and lists
const basicTextTags = [
  'a','b','strong','em','i','sup','sub','p','ul','ol','li',
];

// Exclusively the tags that should appear in a table
const tableTags = [
  'a','b','strong','em','i','sup','sub','table','tbody','thead','tr','th','td',
];

export { subtitleTags, basicTextTags, tableTags };
